var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"badge badge-pill mr-1 c-default",class:[_vm.badgeVariant],attrs:{"title":_vm.badgeTitle}},[_vm._v(_vm._s(_vm.badgeText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744e3d83","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shipment_md/OrderItemTempBadge.vue
// module id = 1666
// module chunks = 0 1